import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const SubTitle = ({ subTitle, isHidden, tag }) => (
  <>{!isHidden && <Text tag={tag} field={subTitle} className="hero-subtitle" />}</>
);

export default SubTitle;
